document.addEventListener('DOMContentLoaded',()=>{
 const header=document.querySelector('[data-header]');
 const mobile=document.querySelector('[data-mobile-nav]');
 const toggle=document.querySelector('[data-mobile-toggle]');
 const close=document.querySelector('[data-mobile-close]');
 const overlay=document.querySelector('[data-overlay]');
 const search=document.querySelector('[data-search-drawer]');
 const searchOpen=document.querySelector('[data-search-open]');
 const searchClose=document.querySelector('[data-search-close]');
 const dropdown=document.querySelector('[data-nav-dropdown]');
 const dropdownButton=dropdown?.querySelector('.nav-dropdown__trigger');
 const mobileAccordion=document.querySelector('[data-mobile-accordion]');
 const mobileSubmenu=document.querySelector('.mobile-nav__submenu');
 const setMobile=(open)=>{mobile?.classList.toggle('is-open',open); document.body.classList.toggle('menu-open',open); overlay?.classList.toggle('is-open',open); if(open) mobile?.querySelector('a')?.focus()};
 toggle?.addEventListener('click',()=>setMobile(true)); close?.addEventListener('click',()=>setMobile(false));
 mobile?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMobile(false)));
 overlay?.addEventListener('click',()=>{setMobile(false);search?.classList.remove('is-open');document.body.classList.remove('search-open');overlay.classList.remove('is-open')});
 searchOpen?.addEventListener('click',()=>{document.body.classList.add('search-open');search?.classList.add('is-open');overlay?.classList.add('is-open');setTimeout(()=>search?.querySelector('input')?.focus(),180)});
 searchClose?.addEventListener('click',()=>{document.body.classList.remove('search-open');search?.classList.remove('is-open');overlay?.classList.remove('is-open')});
 dropdownButton?.addEventListener('click',()=>{const open=!dropdown.classList.contains('is-open');dropdown.classList.toggle('is-open',open);dropdownButton.setAttribute('aria-expanded',open);dropdown.querySelector('.nav-dropdown__menu')?.setAttribute('aria-hidden',!open)});
 document.addEventListener('click',(e)=>{if(dropdown&&!dropdown.contains(e.target)){dropdown.classList.remove('is-open');dropdownButton?.setAttribute('aria-expanded','false')}});
 mobileAccordion?.addEventListener('click',()=>{const collapsed=mobileSubmenu?.classList.toggle('is-collapsed'); mobileAccordion.setAttribute('aria-expanded',!collapsed); mobileAccordion.querySelector('span').textContent=collapsed?'+':'−'});


 // V20: product carousel controls with native smooth scrolling.
 document.querySelectorAll('[data-product-slider]').forEach(slider => {
   const track = slider.querySelector('[data-slider-track]');
   const prev = slider.querySelector('[data-slider-prev]');
   const next = slider.querySelector('[data-slider-next]');
   const step = () => {
     const item = track?.querySelector('.bc-product-slider__item');
     return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 18) : track?.clientWidth || 0;
   };
   prev?.addEventListener('click', () => track?.scrollBy({ left: -step(), behavior: 'smooth' }));
   next?.addEventListener('click', () => track?.scrollBy({ left: step(), behavior: 'smooth' }));
   const update = () => {
     if (!track || !prev || !next) return;
     prev.style.opacity = track.scrollLeft <= 4 ? '.35' : '1';
     next.style.opacity = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4 ? '.35' : '1';
   };
   track?.addEventListener('scroll', update, { passive: true });
   window.addEventListener('resize', update);
   update();
 });

 // V17: gentle reveal-on-scroll for editorial sections and cards.
 document.body.classList.add('js-motion');
 const revealTargets = document.querySelectorAll(
   'main > section, main .editorial-intro, main .category-editorial__card, main .product-card, main .product-grid__item, main .product-editorial__card, main .section-head'
 );
 revealTargets.forEach((el, index) => {
   if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
   if (el.matches('.category-editorial__card, .product-card, .product-grid__item, .product-editorial__card')) {
     el.setAttribute('data-reveal-delay', String((index % 4)));
   }
 });
 if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
   const revealObserver = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         entry.target.classList.add('is-visible');
         observer.unobserve(entry.target);
       }
     });
   }, { threshold: 0.12, rootMargin: '0px 0px -35px 0px' });
   revealTargets.forEach(el => revealObserver.observe(el));
 } else {
   revealTargets.forEach(el => el.classList.add('is-visible'));
 }

 const isHome=document.body.classList.contains('template-index');
 const scroll=()=>{const solid=!isHome||window.scrollY>35||!!window.location.hash;header?.classList.toggle('scrolled',solid);header?.classList.toggle('is-solid',solid)};
 scroll(); window.addEventListener('scroll',scroll,{passive:true});
});


// Gentle editorial crossfade for the homepage brand-story photographs.
document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-story-slideshow]').forEach(function (slideshow) {
    var slides = Array.prototype.slice.call(slideshow.querySelectorAll('.brand-story__slide'));
    if (slides.length < 2) return;
    var current = 0;
    window.setInterval(function () {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 5200);
  });
});

// V32: reliable product variant selection (including gold/silver options).
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-form][data-variants]').forEach(function (formWrap) {
    var form = formWrap.closest('form');
    if (!form) return;
    var variants;
    try { variants = JSON.parse(formWrap.getAttribute('data-variants') || '[]'); } catch (e) { return; }
    if (!variants.length) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.closest('.product-info')?.querySelector('[data-price]');
    var addButton = form.querySelector('.add-btn');
    var optionGroups = Array.prototype.slice.call(formWrap.querySelectorAll('.option'));
    var moneyFormat = (cents) => {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:currency}).format(cents / 100); }
      catch(e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    };
    function currentOptions() {
      return optionGroups.map(function(group) {
        var selected = group.querySelector('.swatch.is-selected');
        return selected ? selected.getAttribute('data-variant-option') : null;
      });
    }
    function applyVariant(variant) {
      if (!variant) {
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Combinaison indisponible'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl && typeof variant.price !== 'undefined') priceEl.textContent = moneyFormat(variant.price);
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (variant.featured_image && variant.featured_image.src) {
        var firstImage = document.querySelector('.product-gallery img');
        if (firstImage) firstImage.src = variant.featured_image.src;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    optionGroups.forEach(function(group) {
      group.querySelectorAll('.swatch').forEach(function(button) {
        button.addEventListener('click', function() {
          group.querySelectorAll('.swatch').forEach(function(item) { item.classList.remove('is-selected'); });
          button.classList.add('is-selected');
          var selected = currentOptions();
          var variant = variants.find(function(item) {
            return item.options && item.options.length === selected.length && item.options.every(function(value, index) { return value === selected[index]; });
          });
          applyVariant(variant);
        });
      });
    });
    var initial = variants.find(function(item) { return idInput && String(item.id) === String(idInput.value); }) || variants.find(function(item) { return item.available; }) || variants[0];
    if (initial && initial.options) {
      initial.options.forEach(function(value, index) {
        var group = optionGroups[index];
        if (!group) return;
        group.querySelectorAll('.swatch').forEach(function(button) {
          button.classList.toggle('is-selected', button.getAttribute('data-variant-option') === value);
        });
      });
      applyVariant(initial);
    }
  });
});
